import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  take,
  tap,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Organisation } from '../../organisation/organisation.interface';
import {
  isIndexLoading,
  organisationById,
  selectCurrentProjects,
  selectCurrentUsers,
} from '../../organisation/organisation.selector';
import {
  loadOrganisationById,
  saveOrganisationColorPalette,
  saveOrganisationFontFamily,
  setCurrentOrganisationID,
} from '../../organisation/organisation.actions';
import { ShapeService } from '../../element-editor/shape/shape.service';
import { User } from '../../user/user.interface';
import {
  deleteProject,
  selectDeleteProjectState,
  selectProjectsByEditTime,
  StudioProject,
} from '../../element-editor/store/studio';
import { setCurrentProjectID } from '../../element-editor/store/editor.actions';

@Component({
  selector: 'nw-organisation-index',
  templateUrl: './organisation-index.component.html',
  styleUrls: ['./organisation-index.component.scss'],
})
export class OrganisationIndexComponent {
  readonly organisationId$: Observable<string>;
  readonly organisation$: Observable<Organisation>;
  readonly isIndexLoading$ = this.store.select(isIndexLoading);

  mode: undefined | 'users' | 'settings';

  get isProjectsMode() {
    return !this.mode;
  }

  get isUsersMode() {
    return this.mode == 'users';
  }

  get isSettingsMode() {
    return this.mode == 'settings';
  }

  orgId: string;

  projects$ = this.store.select(selectProjectsByEditTime);
  users$ = this.store.select(selectCurrentUsers);

  // Style card state
  showColorPaletteModal = false;
  editingPaletteEntries: Array<{ key: string; value: string }> = [];

  deleteProjectState$ = this.store.select(selectDeleteProjectState);

  deleteProjectStates: Record<string, { loading?: boolean; error?: string }> =
    {};
  studioProjects$: Observable<StudioProject[]>;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private router: Router,
    private readonly shapeService: ShapeService,
  ) {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        const hasProject =
          router.url.includes('/p/') && router.url.match(/\/p\/[^/]+/);

        if (!hasProject) {
          this.store.dispatch(setCurrentProjectID({ id: null }));
        }
      });
    // this.router.events.subscribe(() => {
    //   // Get the current path after '/organisation'
    //   const fullPath = this.router.url;
    //   const segments = fullPath.split('/');

    //   const last = segments[segments.length - 1];

    //   if (last == 'users') {
    //     this.mode = 'users';
    //   } else if (last == 'settings') {
    //     this.mode = 'settings';
    //   } else {
    //     this.mode = undefined;
    //   }
    // });

    this.deleteProjectState$.subscribe(state => {
      this.deleteProjectStates = state || {};
    });

    this.studioProjects$ = this.store.select(selectProjectsByEditTime);

    this.organisationId$ = this.route.params.pipe(
      map(({ organisationID }) => organisationID),
      filter(id => !!id),
    );

    this.organisation$ = this.organisationId$.pipe(
      distinctUntilChanged(),
      tap(id => {
        this.orgId = id;
        this.store.dispatch(setCurrentOrganisationID({ ID: id }));
        this.store.dispatch(loadOrganisationById({ id }));
      }),
      mergeMap(id => this.store.select(organisationById(id))),
    );

    // this.organisation$.subscribe(org => {
    // console.log('organisationId', org);
    // this.orgId = id; // -- //
    // });

    this.projects$.subscribe(projects => {
      // console.log('projects', projects);
    });

    console.warn('org-index-comp');
  }

  onProjectClick(id: string) {
    this.router.navigate(['p', id]);
  }

  deleteProject(projectID: string) {
    this.store.dispatch(deleteProject({ projectID }));
  }

  exit() {}
  selectMode(mode?: 'users' | 'settings') {
    this.shapeService.navigateToOrgIndex(mode, this.orgId);
  }

  getUserName(user: User): string {
    if (user.firstName) {
      return user.firstName + ' ' + user.lastName;
    }
    return user.email;
  }

  onAddUser() {
    this.router.navigate(['organisations', this.orgId, 'users', 'new']);
  }
  onAddProject() {
    this.router.navigate(['new']);
  }

  // Style card handlers
  onFontFamilyChange(value: string) {
    const fontFamily = (value || '').trim();
    if (fontFamily) {
      this.store.dispatch(saveOrganisationFontFamily({ fontFamily }));
    }
  }

  openColorPaletteModal() {
    this.organisation$.pipe(filter(Boolean), take(1)).subscribe(org => {
      const palette = (org as Organisation).colorPalette || {};
      this.editingPaletteEntries = Object.entries(palette).map(
        ([key, value]) => ({ key, value }),
      );
      if (this.editingPaletteEntries.length === 0) {
        this.editingPaletteEntries = [{ key: 'primary', value: '#111827' }];
      }
      this.showColorPaletteModal = true;
    });
  }

  closeColorPaletteModal() {
    this.showColorPaletteModal = false;
  }

  addColor() {
    this.editingPaletteEntries.push({
      key: 'color-' + (this.editingPaletteEntries.length + 1),
      value: '#000000',
    });
  }

  removeColor(index: number) {
    this.editingPaletteEntries.splice(index, 1);
  }

  saveColorPalette() {
    const colorPalette: Record<string, string> = {};
    for (const { key, value } of this.editingPaletteEntries) {
      const k = (key || '').trim();
      if (!k) continue;
      colorPalette[k] = value || '#000000';
    }
    this.store.dispatch(saveOrganisationColorPalette({ colorPalette }));
    this.showColorPaletteModal = false;
  }
}
